import { render, staticRenderFns } from "./VRequestChangeServiceModal.vue?vue&type=template&id=72b8caab"
import script from "./VRequestChangeServiceModal.vue?vue&type=script&lang=js"
export * from "./VRequestChangeServiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports